<template>
  <v-flex
    v-if="!loading"
    xs12
    md8
    offset-md2
    align-self-center
    justify-center
  >
    <v-card flat light>
      <EditorTabs
        :editor="editor"
        v-model="currentTab"
        @delete="deleteEditor"
        @edit="editEditor"
      />
      <v-tabs-items v-model="currentTab" light touchless>
        <v-tab-item value="editor">
          <EditorDetails :editor="editor"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-flex>
  <Loader v-else/>
</template>

<script>
  import { mapActions } from 'vuex';

  import { editorsService } from '../../utils/services/editors.service';
  import EditorTabs from '../../components/app/Editors/EditorTabs';
  import EditorDetails from '../../components/app/Editors/EditorDetails';
  import EditorModal from '../../components/modals/Editors/EditorModal';

  import Loader from '../../components/shared/Loader';

  export default {
    name: 'EditorShow',
    components: {
        Loader,
        EditorTabs,
        EditorDetails,
    },
    props: {
      id: [String, Number],
      tab: [String, Number],
    },
    data() {
      return {
        loading: false,
        currentTab: this.tab,
        editor: {},
      };
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      async fetchEditor(id) {
        return editorsService.get(id)
        .then(response => {
          this.editor = response.data.data;
        })
        .catch(error => {
          this.handleError(error, this.errors);
        });
      },
      async deleteEditor() {
        this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return editorsService.remove(this.id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.$router.push(`/${this.routeName.EDITOR}`);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },
      async editEditor() {
          this.showModal({
              component: EditorModal,
               data: {
                  stored: {
                    id: this.id,
                  },
              },
              options: {
                title: this.$t('EDITOR'),
                onSave: (
                  form,
                  error,
                ) => editorsService.save(form)
                .then(() => {
                  this.hideModal({});
                  this.showToast({ type: 'success', message: this.$t('SAVED') });
                })
                .catch(error => {
                  this.handleError(error, this.errors);
                })
                .finally(() => {
                  this.loading = false;
                }),
              },
            });
      },

    },
    async created() {
      this.loading = true;
      await this.fetchEditor(this.id);
      this.loading = false;
    },
  };
</script>
